module.exports = __webpack_public_path__ + "static/media/download_action.115a064d.svg";